import { ReactLocation, Router } from "@tanstack/react-location";
import React from "react";
import { SDKs } from "../constants/routes";

// Set up a ReactLocation instance
const location = new ReactLocation();

const LazyLocalContent = React.lazy(() => import("~/sdks/LocalContent"));
const LazyDemographics = React.lazy(() => import("~/sdks/Demographics"));
const LazyLocalProfiles = React.lazy(() => import("~/sdks/LocalProfiles"));
const LazyLocalNeighbourhoodMap = React.lazy(
  () => import("~/sdks/LocalNeighbourhoodMap"),
);
const LazyLocalNeighborhoodHero = React.lazy(
  () => import("~/sdks/LocalNeighborhoodHero"),
);
const LazyLocalNeighborhoodCharacteristics = React.lazy(
  () => import("~/sdks/LocalNeighborhoodCharacteristics"),
);
const LazyLocalNeighborhoodHighlights = React.lazy(
  () => import("~/sdks/LocalNeighborhoodHighlights"),
);
const LazyLocalNeighborhoodDemographics = React.lazy(
  () => import("../sdks/LocalNeighborhoodDemographics"),
);

interface RouteTemplatesProps {
  children: React.ReactNode;
}

const RouteTemplates: React.FC<RouteTemplatesProps> = ({ children }) => {
  const templateRoutes = [
    {
      path: `/sdks-app/${APP_VERSION}/${SDKs.LOCAL_CONTENT}`,
      element: <LazyLocalContent />,
    },
    {
      path: `/sdks-app/${APP_VERSION}/${SDKs.LOCAL_CONTENT_GOOGLE_MAPS}`,
      element: <LazyLocalContent />,
    },
    {
      path: `/sdks-app/${APP_VERSION}/${SDKs.DEMOGRAPHICS}`,
      element: <LazyDemographics />,
    },
    {
      path: `/sdks-app/${APP_VERSION}/${SDKs.LOCAL_PROFILES}`,
      element: <LazyLocalProfiles />,
    },
    {
      path: `/sdks-app/${APP_VERSION}/${SDKs.LOCAL_NEIGHBOURHOOD_MAP}`,
      element: <LazyLocalNeighbourhoodMap />,
    },
    {
      path: `/sdks-app/${APP_VERSION}/${SDKs.LOCAL_NEIGHBOURHOOD_MAP_GOOGLE_MAPS}`,
      element: <LazyLocalNeighbourhoodMap />,
    },
    {
      path: `/sdks-app/${APP_VERSION}/${SDKs.LOCAL_NEIGHBORHOOD_HERO}`,
      element: <LazyLocalNeighborhoodHero />,
    },
    {
      path: `/sdks-app/${APP_VERSION}/${SDKs.LOCAL_NEIGHBORHOOD_CHARACTERISTICS}`,
      element: <LazyLocalNeighborhoodCharacteristics />,
    },
    {
      path: `/sdks-app/${APP_VERSION}/${SDKs.LOCAL_NEIGHBORHOOD_HIGHLIGHTS}`,
      element: <LazyLocalNeighborhoodHighlights />,
    },
    {
      path: `/sdks-app/${APP_VERSION}/${SDKs.LOCAL_NEIGHBORHOOD_DEMOGRAPHICS}`,
      element: <LazyLocalNeighborhoodDemographics />,
    },
  ];

  return (
    <Router location={location} routes={templateRoutes}>
      {children}
    </Router>
  );
};

export default RouteTemplates;
